"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackReact = exports.Feedback = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _store = require("../../store");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../store/constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FeedbackReact = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FeedbackReact, _React$Component);
  var _super = _createSuper(FeedbackReact);
  function FeedbackReact() {
    var _this;
    (0, _classCallCheck2.default)(this, FeedbackReact);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sendFeedback", function () {
      _this.props.fireFeedback();
    });
    return _this;
  }
  (0, _createClass2.default)(FeedbackReact, [{
    key: "render",
    value: function render() {
      var table = this.props.table;
      var feedbackContent = '';
      if (table.resultType === _constants.FUZZY && table.request === _constants.COMPLETE || table.resultType === _constants.NOMATCH && table.request === _constants.COMPLETE) {
        feedbackContent = table && !table.feedback ? /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("button", {
          onClick: this.sendFeedback,
          className: "pf-feedback"
        }, "Click here"), " to help us connect with providers you couldn\u2019t find.") : /*#__PURE__*/_react.default.createElement("p", null, "Thank you for your feedback. Your engagement will help us in our efforts to reach out to providers outside of the LendingClub network and onboard them.");
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "feedback"
      }, feedbackContent);
    }
  }]);
  return FeedbackReact;
}(_react.default.Component);
exports.FeedbackReact = FeedbackReact;
var mapStateToProps = function mapStateToProps(state) {
  return {
    table: state.table
  };
};
FeedbackReact.propTypes = {
  fireFeedback: _propTypes.default.func,
  table: _propTypes.default.object
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_objectSpread({}, _store.actions), dispatch);
};
var Feedback = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(FeedbackReact);
exports.Feedback = Feedback;
